import styled from '@emotion/styled';

import { fontFamily, fontWeight } from 'ms-styles/base';

export const FlagsWrapper = styled.div({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'center',
  flexWrap: 'wrap',
  minHeight: 200,
});

const BUTTON_FLAG_WRAPPER_SIZE = 130;
export const ButtonFlagWrapper = styled.div({
  flexShrink: 0,
  flexGrow: 0,
  width: BUTTON_FLAG_WRAPPER_SIZE,
  height: BUTTON_FLAG_WRAPPER_SIZE,
  marginTop: 16,
  marginBottom: 16,
});

export const FlagWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  alignItems: 'center',
});

export const FlagLabel = styled.div({
  fontFamily: fontFamily.body,
  fontWeight: fontWeight.semibold,
  fontSize: 14,
  lineHeight: '18px',
  marginTop: 24,
  textAlign: 'center',
});

export const Flag = styled.img({
  width: 90,
  height: 60,
});
